import { useContext } from 'react';
import { useParams } from 'react-router';

import { PostDetailsContext } from '@/contexts/PostDetailsContext';
import { ViolationContext } from '@/contexts/ViolationContext';
import { LabelsCard } from '@/views/labels/components/LabelsCard';

const PostLabels = ({ isViolation = false }: { isViolation?: boolean }) => {
  const postId = Number(useParams().postId);

  const violationContext = useContext(ViolationContext);
  const postDetailsContext = useContext(PostDetailsContext);
  const data = isViolation
    ? (violationContext as any)?.violationData
    : (postDetailsContext as any)?.data;

  if (!data) return <></>;

  return <LabelsCard postId={postId} labels={data.labels ?? []} />;
};

export default PostLabels;
